import { Component, Inject, OnInit, Optional } from '@angular/core';
import { FormBuilder, FormControl, FormGroup, Validators } from '@angular/forms';
import { MatDialogRef, MAT_DIALOG_DATA } from '@angular/material/dialog';
import { Observable } from 'rxjs';
import { map } from 'rxjs/operators';
import { DataService } from '../../providers/data.service';
import { DifficultymodifiersService } from '../../providers/difficultymodifiers/difficultymodifiers.service';

@Component({
  selector: 'app-difficulty-modifier-modal',
  templateUrl: './difficulty-modifier-modal.component.html',
  styleUrls: ['./difficulty-modifier-modal.component.scss'],
  providers: [DataService]
})
export class DifficultyModifierModalComponent implements OnInit {
  modifierForm: FormGroup;
  editing: boolean = false;

  public dataLevelList$: Observable<[]>;
  public dataQuestionDifficultyList$: Observable<[]>;

  constructor(
    public fb: FormBuilder,
    public dialogRef: MatDialogRef<DifficultyModifierModalComponent>,
    public dataService: DataService,
    public modifierService: DifficultymodifiersService,
    @Optional() @Inject(MAT_DIALOG_DATA) public data: any
  ) {
    console.log(data);
    if (!this.data.id) {
      this.createForm();
    } else {
      this.editing = true;
      this.editForm();
    }
  }

  ngOnInit(): void {
    //level list
    this.dataLevelList$ = this.dataService.LevelList;
    this.dataService.getLevelData().subscribe();

    //question difficulty list
    this.dataQuestionDifficultyList$ = this.dataService.QuestionDifficultyList;
    this.dataService.getQuestionDifficultyData().subscribe();
  }

  createForm() {
    this.modifierForm = new FormGroup({
      sysRef: new FormControl(),
      Level_SysRef: new FormControl(),
      QuestionDifficulty_SysRef: new FormControl()
    });

    this.modifierForm = this.fb.group({
      sysRef: [],
      Level_SysRef: ['', [Validators.required]],
      QuestionDifficulty_SysRef: ['', [Validators.required]],
    })

  }

  editForm() {
    this.modifierForm = new FormGroup({
      sysRef: new FormControl(),
      Level_SysRef: new FormControl(),
      QuestionDifficulty_SysRef: new FormControl()
    });

    this.modifierForm = this.fb.group({
      sysRef: [this.data.id],
      Level_SysRef: [this.data.Level.sysRef, [Validators.required]],
      QuestionDifficulty_SysRef: [this.data.QuestionDifficulty.sysRef, [Validators.required]],
    })
  }

  onNoClick(): void {
    this.dialogRef.close();
  }

  Add() {
    if (!this.data.id) {
      console.log(this.modifierForm.value);
      this.modifierService.addModifier(this.modifierForm.value)
        .pipe(map(
          data => { console.log(data); return data },
          err => { console.log(err); return err }
        ))
        .subscribe(
          data => {
            return data;
          },
          err => { alert("Invalid data"); console.log(err) }
        );
    } else {
      console.log(this.modifierForm.value);
      this.modifierService.editModifier(this.data.id, this.modifierForm.value)
        .pipe(map(
          data => { console.log(data); return data },
          err => { console.log(err); return err }
        ))
        .subscribe(
          data => {
            return data;
          },
          err => { alert("Invalid data"); console.log(err) }
        );
    }

  }

}
